<div class="popover-menu-content">
	@for(unit of units; track unit; let last = $last) {
		<app-item [underlined]="!last" appNavigable (click)="unitSelected(unit)">
			<app-item-label>{{ unit.label }}</app-item-label>
		</app-item>
	}
</div>